import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { validateMaintenanceAccess, maintenanceExternalError } from './maintenanceExternalApi';
import { saveMaintenanceSession } from './maintenanceExternalSession';
import { MaintenanceErrorState, MaintenanceLinearLoading, MaintenancePageShell } from './MaintenancePageShell';

export default function MaintenanceAccessPage() {
  const { token = '' } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const sequence = useRef(0);

  const validate = () => {
    const request = ++sequence.current;
    setError('');
    const controller = new AbortController();
    validateMaintenanceAccess(token, controller.signal)
      .then(access => {
        if (request !== sequence.current) return;
        saveMaintenanceSession(token, access);
        navigate('/maintenance/tasks', { replace: true });
      })
      .catch(reason => {
        if (request !== sequence.current || reason?.code === 'ERR_CANCELED') return;
        setError(maintenanceExternalError(reason, 'This maintenance link is invalid or has expired.'));
      });
    return () => controller.abort();
  };

  useEffect(() => {
    if (!token.trim()) {
      setError('This maintenance link is incomplete. Please ask your manager for a new link.');
      return undefined;
    }
    return validate();
  }, [token]);

  return (
    <MaintenancePageShell>
      {error ? (
        <MaintenanceErrorState
          title="Maintenance link needs attention"
          message={error}
          onRetry={token.trim() ? validate : undefined}
        />
      ) : (
        <MaintenanceLinearLoading title="Opening your maintenance tasks" detail="Checking the secure link and preparing your centres." />
      )}
    </MaintenancePageShell>
  );
}
